import { Component, OnInit, Input } from '@angular/core';
import { Cliente } from '../cliente.model';
import { Router } from '@angular/router';
import { EstadoCliente } from '../estadoCliente.model';
import { SecurityService } from '../../security/security.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material';
import { BackendService } from '../../core/backend.service';
import { SnackService } from '../../shared-services/snack.service';

@Component({
  selector: 'app-cliente-table',
  templateUrl: './cliente-table.component.html',
  styleUrls: ['./cliente-table.component.scss']
})
export class ClienteTableComponent implements OnInit {

  @Input() clientesList: Cliente[];
  public EstadoCliente = new EstadoCliente();
  constructor(
    public router: Router,
    public securityService: SecurityService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private backendService: BackendService,
    private snackService: SnackService
  ) {
    this.matIconRegistry.addSvgIcon(
      'pend_revision_act_doc',
      this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/sharp-notification_important.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'pend_aprobacion_email',
      this.domSanitizer.bypassSecurityTrustResourceUrl('./assets/images/sharp-unsubscribe.svg')
    );
  }

  ngOnInit() {
    console.log(this.clientesList);
  }

  detallesCliente(id: number) {
    this.router.navigate(['/clientes/detalles', id]);
  }

  onVerAcuerdos(cliente: Cliente) {
    this.router.navigate(['/clientes/ver-acuerdos', cliente.id]);
  }

  descargarUltimoPresupuesto(clienteId){
    this.snackService.spinner(true);
    this.backendService.getPresupuesto(Cliente.path +'ultimo-presupuesto/'+ clienteId, null).toPromise().then(a =>{
      this.createBlob(a);
      this.snackService.spinner(false);
      
     })
  }

  createBlob(pdf: any) {
    const blob = new Blob([pdf], {type: 'application/pdf'});
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/cliente-table/cliente-table.component.ts